package pnemonic.balloon_pop.drawable

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Bonus: ImageVector
    get() {
        if (_Bonus != null) {
            return _Bonus!!
        }
        _Bonus = ImageVector.Builder(
            name = "Bonus",
            defaultWidth = 31.4.dp,
            defaultHeight = 30.22.dp,
            viewportWidth = 31.4f,
            viewportHeight = 30.22f
        ).apply {
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0.01f to Color(0xFF005703),
                        0.238f to Color(0xFF17640D),
                        0.745f to Color(0xFF448020),
                        1f to Color(0xFF568A28)
                    ),
                    start = Offset(8.919f, 10.785f),
                    end = Offset(8.059f, 29.795f)
                )
            ) {
                moveTo(15.976f, 30.218f)
                lineToRelative(0f, -17.969f)
                lineToRelative(-14.887f, -3.793f)
                lineToRelative(0f, 17.495f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(2.814f, 8.896f)
                lineToRelative(-1.725f, -0.439f)
                lineToRelative(0f, 2.557f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(1.089f, 25.063f)
                lineToRelative(9.231f, -14.254f)
                lineToRelative(-4.007f, -1.021f)
                lineToRelative(-5.224f, 7.705f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(15.976f, 12.249f)
                lineToRelative(-1.586f, -0.404f)
                lineToRelative(-9.457f, 15.208f)
                lineToRelative(4.075f, 1.168f)
                lineToRelative(6.968f, -11.127f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(15.976f, 25.328f)
                lineToRelative(-2.689f, 4.12f)
                lineToRelative(2.689f, 0.771f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFF4B8900),
                        1f to Color(0xFFBFC654)
                    ),
                    start = Offset(15.029f, 34.499f),
                    end = Offset(28.21f, 10.033f)
                )
            ) {
                moveTo(15.882f, 30.218f)
                lineToRelative(0f, -17.969f)
                lineToRelative(14.887f, -3.793f)
                lineToRelative(0f, 17.495f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(18.597f, 11.558f)
                lineToRelative(-2.715f, 0.692f)
                lineToRelative(0f, 5.145f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(26.478f, 9.55f)
                lineToRelative(-3.698f, 0.942f)
                lineToRelative(-6.898f, 15.083f)
                lineToRelative(0f, 4.643f)
                lineToRelative(1.573f, -0.451f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(30.769f, 13.673f)
                lineToRelative(0f, -5.217f)
                lineToRelative(-0.974f, 0.248f)
                lineToRelative(-8.18f, 19.87f)
                lineToRelative(4.258f, -1.221f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(30.769f, 25.951f)
                lineToRelative(0f, -4.745f)
                lineToRelative(-1.911f, 5.292f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF190101)),
                fillAlpha = 0.2f,
                strokeAlpha = 0.2f
            ) {
                moveTo(30.769f, 8.457f)
                lineToRelative(-29.643f, 0.371f)
                lineToRelative(0f, 0.948f)
                lineToRelative(14.793f, 4.362f)
                lineToRelative(14.793f, -4.551f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFF3A791C),
                        0.99f to Color(0xFF005703)
                    ),
                    start = Offset(20.857f, 13.67f),
                    end = Offset(-11.487f, 2.143f)
                )
            ) {
                moveTo(15.726f, 13.15f)
                lineToRelative(0f, -3.769f)
                lineToRelative(-15.726f, -4.337f)
                lineToRelative(0f, 3.654f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(8.08f, 10.985f)
                lineToRelative(3.585f, -2.724f)
                lineToRelative(-3.355f, -0.925f)
                lineToRelative(-3.233f, 2.799f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(5.5f, 6.561f)
                lineToRelative(-3.102f, -0.856f)
                lineToRelative(-2.398f, 2.052f)
                lineToRelative(0f, 0.94f)
                lineToRelative(2.192f, 0.621f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(15.726f, 13.15f)
                lineToRelative(0f, -3.769f)
                lineToRelative(-0.842f, -0.232f)
                lineToRelative(-3.724f, 2.709f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFF4B8900),
                        1f to Color(0xFFBFC654)
                    ),
                    start = Offset(33.952f, 6.642f),
                    end = Offset(10.151f, 12.237f)
                )
            ) {
                moveTo(15.646f, 13.15f)
                lineToRelative(0f, -3.769f)
                lineToRelative(15.726f, -4.337f)
                lineToRelative(0f, 3.559f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(15.824f, 13.099f)
                lineToRelative(2.117f, -4.351f)
                lineToRelative(-2.295f, 0.633f)
                lineToRelative(0f, 3.769f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(19.596f, 12.008f)
                lineToRelative(3.752f, -1.085f)
                lineToRelative(1.994f, -4.216f)
                lineToRelative(-3.654f, 1.008f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(31.372f, 7.102f)
                lineToRelative(0f, -2.058f)
                lineToRelative(-2.353f, 0.649f)
                lineToRelative(-1.841f, 4.123f)
                lineToRelative(3.617f, -1.046f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFF4B8900),
                        1f to Color(0xFFBFC654)
                    ),
                    start = Offset(10.981f, 0.003f),
                    end = Offset(20.274f, 9.96f)
                )
            ) {
                moveTo(31.372f, 5.044f)
                lineToRelative(-15.548f, -3.612f)
                lineToRelative(-15.824f, 3.612f)
                lineToRelative(15.646f, 4.337f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(1.4f, 5.432f)
                lineToRelative(3.515f, 0.974f)
                lineToRelative(3.22f, -3.22f)
                lineToRelative(-5.818f, 1.328f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(17.924f, 1.919f)
                lineToRelative(-2.1f, -0.488f)
                lineToRelative(-2.033f, 0.464f)
                lineToRelative(-5.458f, 5.458f)
                lineToRelative(3.255f, 0.902f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(24.334f, 3.408f)
                lineToRelative(-3.036f, -0.705f)
                lineToRelative(-6.455f, 6.455f)
                lineToRelative(0.804f, 0.223f)
                lineToRelative(3.749f, -1.034f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                fillAlpha = 0.15f,
                strokeAlpha = 0.15f
            ) {
                moveTo(28.981f, 5.703f)
                lineToRelative(0.986f, -0.986f)
                lineToRelative(-2.699f, -0.627f)
                lineToRelative(-2.879f, 2.879f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0.526f to Color(0xFFEEE824),
                        0.639f to Color(0xFFD1CC1F),
                        0.787f to Color(0xFFB2AC19),
                        0.913f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(7.598f, -18.346f),
                    end = Offset(7.598f, 28.624f)
                )
            ) {
                moveTo(8.983f, 7.538f)
                lineToRelative(-2.577f, -0.626f)
                lineToRelative(-0.193f, 20.798f)
                lineToRelative(2.77f, 0.794f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0.526f to Color(0xFFEEE824),
                        0.639f to Color(0xFFD1CC1F),
                        0.787f to Color(0xFFB2AC19),
                        0.913f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(24.23f, 2.827f),
                    end = Offset(24.23f, 33.697f)
                )
            ) {
                moveTo(22.844f, 7.395f)
                lineToRelative(2.577f, -0.709f)
                lineToRelative(0.193f, 20.905f)
                lineToRelative(-2.77f, 0.794f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0.191f to Color(0xFFF5EE6A),
                        0.395f to Color(0xFFF0EA3D),
                        0.526f to Color(0xFFEEE824),
                        0.54f to Color(0xFFEBE623),
                        0.729f to Color(0xFFCCC61D),
                        0.889f to Color(0xFFB9B319),
                        1f to Color(0xFFB3AC17)
                    ),
                    start = Offset(29.14f, 11.536f),
                    end = Offset(13.399f, 3f)
                )
            ) {
                moveTo(8.382f, 3.113f)
                lineToRelative(14.462f, 4.305f)
                lineToRelative(2.577f, -0.732f)
                lineToRelative(-13.83f, -4.325f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0.191f to Color(0xFFF5EE6A),
                        0.395f to Color(0xFFF0EA3D),
                        0.526f to Color(0xFFEEE824),
                        0.54f to Color(0xFFEBE623),
                        0.729f to Color(0xFFCCC61D),
                        0.889f to Color(0xFFB9B319),
                        1f to Color(0xFFB3AC17)
                    ),
                    start = Offset(-9.89f, 21.032f),
                    end = Offset(29.241f, -3.91f)
                )
            ) {
                moveTo(8.983f, 7.538f)
                lineToRelative(14.855f, -4.27f)
                lineToRelative(-2.354f, -0.545f)
                lineToRelative(-15.079f, 4.189f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFEEE824),
                        0.047f to Color(0xFFEFE92D),
                        0.126f to Color(0xFFF1EB47),
                        0.226f to Color(0xFFF5EF71),
                        0.29f to Color(0xFFF8F28F),
                        0.405f to Color(0xFFECE77C),
                        0.809f to Color(0xFFC6C03E),
                        1f to Color(0xFFB7B125)
                    ),
                    start = Offset(16.117f, -0.441f),
                    end = Offset(16.117f, 5.718f)
                )
            ) {
                moveTo(17.485f, -0f)
                lineToRelative(-0.397f, 4.148f)
                lineToRelative(-1.897f, -0.103f)
                lineToRelative(-0.441f, -4.045f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFC3BD1C),
                        0.29f to Color(0xFFB2AC19),
                        0.709f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(9.125f, 5.04f),
                    end = Offset(15.754f, 5.04f)
                )
            ) {
                moveTo(13.048f, 4.217f)
                lineToRelative(-2.687f, 0.392f)
                lineToRelative(-1.236f, 1.255f)
                lineToRelative(6.629f, -0.216f)
                lineToRelative(-0.294f, -0.51f)
                close()
            }
            path(
                fill = Brush.radialGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFF5EE6A),
                        0.118f to Color(0xFFF4ED62),
                        0.499f to Color(0xFFF1EC49),
                        0.627f to Color(0xFFE7E343),
                        0.84f to Color(0xFFCEC934),
                        1f to Color(0xFFB7B125)
                    ),
                    center = Offset(12.524f, 4.567f),
                    radius = 2.578f
                )
            ) {
                moveToRelative(15.931f, 4.923f)
                curveToRelative(0f, 0f, -2.628f, -3.02f, -6.296f, -0.902f)
                curveToRelative(0f, 0f, -0.588f, 1.942f, -0.51f, 1.844f)
                curveToRelative(0.079f, -0.098f, 2.236f, -1.902f, 6.629f, -0.216f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFC3BD1C),
                        0.29f to Color(0xFFB2AC19),
                        0.709f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(23.369f, 5.04f),
                    end = Offset(16.74f, 5.04f)
                )
            ) {
                moveTo(19.446f, 4.217f)
                lineToRelative(2.687f, 0.392f)
                lineToRelative(1.236f, 1.255f)
                lineToRelative(-6.629f, -0.216f)
                lineToRelative(0.294f, -0.51f)
                close()
            }
            path(
                fill = Brush.radialGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFF5EE6A),
                        0.118f to Color(0xFFF4ED62),
                        0.499f to Color(0xFFF1EC49),
                        0.627f to Color(0xFFE7E343),
                        0.84f to Color(0xFFCEC934),
                        1f to Color(0xFFB7B125)
                    ),
                    center = Offset(19.97f, 4.567f),
                    radius = 2.578f
                )
            ) {
                moveToRelative(16.563f, 4.923f)
                curveToRelative(0f, 0f, 2.628f, -3.02f, 6.296f, -0.902f)
                curveToRelative(0f, 0f, 0.588f, 1.942f, 0.51f, 1.844f)
                curveToRelative(-0.079f, -0.098f, -2.236f, -1.902f, -6.629f, -0.216f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFEEE824),
                        0.047f to Color(0xFFEFE92D),
                        0.126f to Color(0xFFF1EB47),
                        0.226f to Color(0xFFF5EF71),
                        0.29f to Color(0xFFF8F28F),
                        0.405f to Color(0xFFECE77C),
                        0.809f to Color(0xFFC6C03E),
                        1f to Color(0xFFB7B125)
                    ),
                    start = Offset(16.116f, 5.56f),
                    end = Offset(16.116f, 8.753f)
                )
            ) {
                moveToRelative(16.068f, 4.923f)
                curveToRelative(0f, 0f, -2.589f, -0.451f, -2.353f, 2.726f)
                lineTo(18.5f, 7.649f)
                curveToRelative(0f, 0f, 0.471f, -2.981f, -2.157f, -2.628f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFC3BD1C),
                        0.29f to Color(0xFFB2AC19),
                        0.709f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(15.076f, 4.404f),
                    end = Offset(10.997f, 0.344f)
                )
            ) {
                moveToRelative(11.94f, 1.78f)
                curveToRelative(0f, 0f, 0.029f, 1.829f, 3.697f, 2.633f)
                lineToRelative(-0.176f, -0.686f)
                curveToRelative(0f, 0f, -2.452f, -0.471f, -3.55f, -2.638f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFEEE824),
                        0.047f to Color(0xFFEFE92D),
                        0.126f to Color(0xFFF1EB47),
                        0.226f to Color(0xFFF5EF71),
                        0.29f to Color(0xFFF8F28F),
                        0.405f to Color(0xFFECE77C),
                        0.809f to Color(0xFFC6C03E),
                        1f to Color(0xFFB7B125)
                    ),
                    start = Offset(13.83f, 1.123f),
                    end = Offset(13.83f, 6.619f)
                )
            ) {
                moveToRelative(15.749f, 4.383f)
                curveToRelative(0f, 0f, -1.118f, -4.942f, -3.81f, -2.603f)
                lineToRelative(-0.029f, -0.691f)
                curveToRelative(0f, 0f, 2.353f, -2.824f, 3.736f, 2.412f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFC3BD1C),
                        0.29f to Color(0xFFB2AC19),
                        0.709f to Color(0xFF9F9915),
                        1f to Color(0xFF989214)
                    ),
                    start = Offset(17.256f, 4.404f),
                    end = Offset(21.335f, 0.344f)
                )
            ) {
                moveToRelative(20.393f, 1.78f)
                curveToRelative(0f, 0f, -0.029f, 1.829f, -3.697f, 2.633f)
                lineToRelative(0.176f, -0.686f)
                curveToRelative(0f, 0f, 2.452f, -0.471f, 3.55f, -2.638f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFEEE824),
                        0.047f to Color(0xFFEFE92D),
                        0.126f to Color(0xFFF1EB47),
                        0.226f to Color(0xFFF5EF71),
                        0.29f to Color(0xFFF8F28F),
                        0.405f to Color(0xFFECE77C),
                        0.809f to Color(0xFFC6C03E),
                        1f to Color(0xFFB7B125)
                    ),
                    start = Offset(18.503f, 1.123f),
                    end = Offset(18.503f, 6.619f)
                )
            ) {
                moveToRelative(16.583f, 4.383f)
                curveToRelative(0f, 0f, 1.118f, -4.942f, 3.81f, -2.603f)
                lineToRelative(0.029f, -0.691f)
                curveToRelative(0f, 0f, -2.353f, -2.824f, -3.736f, 2.412f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFEEE824),
                        0.047f to Color(0xFFEFE92D),
                        0.126f to Color(0xFFF1EB47),
                        0.226f to Color(0xFFF5EF71),
                        0.29f to Color(0xFFF8F28F),
                        0.405f to Color(0xFFECE77C),
                        0.809f to Color(0xFFC6C03E),
                        1f to Color(0xFFB7B125)
                    ),
                    start = Offset(16.186f, 3.481f),
                    end = Offset(16.186f, 5.286f)
                )
            ) {
                moveTo(14.558f, 3.511f)
                lineToRelative(3.256f, 0f)
                lineToRelative(0f, 2.001f)
                lineToRelative(-3.256f, 0f)
                close()
            }
        }.build()

        return _Bonus!!
    }

@Suppress("ObjectPropertyName")
private var _Bonus: ImageVector? = null
